/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateAdDesignDataSchema = z.object({
	name: z.string().nullable().optional(),
	document: z.string().nullable().optional(),
	thumbnailMediaId: z.string().uuid().nullable().optional(),
})

export type UpdateAdDesignDataSchema = z.infer<typeof updateAdDesignDataSchema>
